module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("To Mark,")])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("who puts up with my nail polish obsession")])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("with love and a big smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication-ded"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Love you!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cb6c9d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0